import { IMarkedList, ISeoPageData } from '../../types/seo';
import { TSeoDataAction, TMarkedListAction, SeoDataActionTypes, MarkedListActionTypes } from './actions';

export type TSeoAction = TSeoDataAction | TMarkedListAction;

export interface ISeo {
  pageData?: ISeoPageData;
  markedList?: IMarkedList;
}

export function seoReducer(state: ISeo, action: TSeoAction): ISeo {
  switch (action.type) {
    case SeoDataActionTypes.Fetched:
      return {
        ...state,
        pageData: action.data,
      };
    case MarkedListActionTypes.Fetched:
      return {
        ...state,
        markedList: action.data,
      };
    default:
      return state || {};
  }
}
